var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJoinAndTwo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 30,
    viewBox: "0 0 42 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 27.0639C25.3256 24.7773 28.2733 20.2326 28.2733 14.9994C28.2733 9.76613 25.3256 5.22137 21 2.9348C16.6744 5.22137 13.7268 9.76613 13.7268 14.9994C13.7268 20.2326 16.6744 24.7773 21 27.0639Z",
    fill: "#00A8B8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0019 27.064C25.3275 24.7774 28.2752 20.2326 28.2752 14.9994C28.2752 9.76617 25.3275 5.22141 21.0019 2.93483C22.9019 1.93049 25.0676 1.36182 27.3662 1.36182C34.8981 1.36182 41.0038 7.46757 41.0038 14.9994C41.0038 22.5312 34.8981 28.637 27.3662 28.637C25.0676 28.637 22.9019 28.0683 21.0019 27.064Z",
    fill: "#B3C9CB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0019 2.93483C16.6762 5.22137 13.7287 9.76632 13.7287 14.9996C13.7287 20.2328 16.6764 24.7773 21.0019 27.064C19.102 28.0682 16.9361 28.637 14.6376 28.637C7.10575 28.637 1 22.5312 1 14.9994C1 7.46757 7.10575 1.36182 14.6376 1.36182C16.9363 1.36182 19.1019 1.93042 21.0019 2.93483Z",
    fill: "#B3C9CB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0019 27.064C25.3275 24.7774 28.2752 20.2326 28.2752 14.9994C28.2752 9.76617 25.3275 5.22141 21.0019 2.93483M21.0019 27.064C22.9019 28.0683 25.0676 28.637 27.3662 28.637C34.8981 28.637 41.0038 22.5312 41.0038 14.9994C41.0038 7.46757 34.8981 1.36182 27.3662 1.36182C25.0676 1.36182 22.9019 1.93049 21.0019 2.93483M21.0019 27.064C16.6764 24.7773 13.7287 20.2328 13.7287 14.9996C13.7287 9.76632 16.6762 5.22137 21.0019 2.93483M21.0019 27.064C19.102 28.0682 16.9361 28.637 14.6376 28.637C7.10575 28.637 1 22.5312 1 14.9994C1 7.46757 7.10575 1.36182 14.6376 1.36182C16.9363 1.36182 19.1019 1.93042 21.0019 2.93483M28.2733 14.9994C28.2733 20.2326 25.3256 24.7773 21 27.0639C16.6744 24.7773 13.7268 20.2326 13.7268 14.9994C13.7268 9.76613 16.6744 5.22137 21 2.9348C25.3256 5.22137 28.2733 9.76613 28.2733 14.9994Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoinAndTwo);
export default __webpack_public_path__ + "static/media/join-and-two.7320d49372d0cdab4d7af8c002de3b12.svg";
export { ForwardRef as ReactComponent };